import {AccountingRuleList, AccountingRuleRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Chip, TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const AccountingRuleListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<AccountingRuleList> = {
        title: "Reglas contables",
        onClick: "/app/admin/accounting/rule",
        headers: [
            {title: "Evento"},
            {title: "Cuenta debe"},
            {title: "Cuenta haber"},
            {title: "% Impuesto"},
            {title: "Activa"},
        ],
        decorator: (bean: AccountingRuleList) => (
            <>
                <TableCell>
                    <Chip label={bean.event} size="small" color="primary"/>
                </TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>
                    {bean.debitAccount?.code} - {bean.debitAccount?.name}
                </TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>
                    {bean.creditAccount?.code} - {bean.creditAccount?.name}
                </TableCell>
                <TableCell>{bean.taxRate != null ? `${bean.taxRate}%` : "-"}</TableCell>
                <TableCell>{bean.active ? "Sí" : "No"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(AccountingRuleRestControllerApiFactory);
            return ctrl.pageAccountingRule(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
